/*
 * Sticky add-to-cart bar — Beam Glow LP family. Reveals the bar once the user
 * scrolls past the hero and the buy box (if present) is out of view. rAF-
 * throttled. Document-wide + guarded so it runs once.
 */
(function () {
  if (window.__glpStickyLp) return;
  window.__glpStickyLp = true;

  function init() {
    var sticky = document.querySelector(".glp-sticky");
    if (!sticky) return;
    var buybox = document.querySelector(".glp-buybox");
    var ticking = false;

    function update() {
      var show = window.scrollY > 500;
      if (show && buybox) {
        var r = buybox.getBoundingClientRect();
        show = r.top > window.innerHeight || r.bottom < 0;
      }
      sticky.classList.toggle("show", show);
      ticking = false;
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
